const lang = {
    en: {
      search: "Let's Go!",
      gptSearchPlaceholder: "What do you wanna watch today, Boss?",
    },
    hindi: {
      search: "आइए खोजें!",
      gptSearchPlaceholder: "आज आप क्या देखना चाहते हैं, बॉस?",
    },
    spanish: {
      search: "buscar",
      gptSearchPlaceholder: "¿Qué quieres ver hoy, jefe?",
    },
  };
  
  export default lang;
  